import { getHeaders, getKonnectHeaders } from './common';

// Check Login status
export const checkLoginStatus = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/check-login-status`, {
            method: 'GET',
            headers: getHeaders(),
            credentials: 'include',
        });

        if (response.ok) {
            const data = await response.json();
            return { success: true, data };
        } else {
            return { success: false, error: 'Login session expired' };
        }
    } catch (error) {
        console.error('Login status check error:', error);
        return { success: false, error: 'An error occurred. Please try again.' };
    }
};

// User login
export const loginUser = async (email, password, rememberMe) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/login`, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify({ email, password, rememberMe }),
            credentials: 'include',
        });

        if (response.ok) {
            const data = await response.json();
            return { success: true, data };
        } else if (response.status === 401) {
            return { success: false, error: "Incorrect email or password. Please try again." };
        } else {
            const errorData = await response.json();
            return {
                success: false,
                error: errorData.message || "An unexpected error occurred. Please try again."
            };
        }
    } catch (error) {
        console.error('Login error:', error);
        return { success: false, error: 'An error occurred. Please try again.' };
    }
};

export const logout = async () => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/logout`,
            {
                method: "POST",
                headers: getHeaders(),
                credentials: "include",
            }
        );

        return {
            success: response.ok,
            error: response.ok ? null : "Logout failed"
        };
    } catch (error) {
        console.error("Logout error:", error);
        return { success: false, error: "Error logging out" };
    }
};

export const checkAccountStatus = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/check-login-status`, {
            method: 'GET',
            credentials: 'include',
        });

        if (response.ok) {
            const data = await response.json();
            return {
                success: true,
                isAuthenticated: data.isAuthenticated,
                accountDeleted: data.accountDeleted
            };
        } else {
            console.error('Failed to check login status');
            return {
                success: false,
                isAuthenticated: false,
                accountDeleted: false
            };
        }
    } catch (error) {
        console.error('Error checking login status:', error);
        return {
            success: false,
            isAuthenticated: false,
            accountDeleted: false,
            error: error.message
        };
    }
};

//Reset Password
export const resetPassword = async (email, newPassword, token) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/reset-password`,
            {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify({
                    Email: email,
                    NewPassword: newPassword,
                    Token: token,
                }),
                credentials: 'include',
            }
        );

        if (response.ok) {
            return { success: true, message: "Password has been set!" };
        } else if (response.status === 400) {
            return {
                success: false,
                message: "Your link has expired. Please go to the Forgot Password page and generate a new password reset link."
            };
        } else {
            throw new Error('Unexpected response');
        }
    } catch (error) {
        console.error('Reset password error:', error);
        return {
            success: false,
            message: 'Your link has expired. Please go to the Forgot Password page and generate a new password reset link.'
        };
    }
};

// Send reset email
export const sendResetPasswordEmail = async (email) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/forgot-password`,
            {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify({ Email: email }),
                credentials: 'include',
            }
        );

        if (response.ok) {
            return { success: true, message: "The email has been sent!" };
        } else if (response.status === 500) {
            return { success: false, message: "Email not exist!" };
        } else {
            throw new Error('Unexpected response');
        }
    } catch (error) {
        console.error('Send reset email error:', error);
        return { success: false, message: "Failed to send email, please try again!" };
    }
};

//#region Konnct

export const RegisterKonnectDevice = async (name, konnekt_device_id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/konnekt`, {
            method: 'POST',
            headers: getKonnectHeaders(),
            body: JSON.stringify({ name, konnekt_device_id })
        });

        if (response.ok) {
            const data = await response.json();
            return { success: true, data };
        } else if (response.status === 401) {
            return { success: false, error: "An error occurred. Please try again." };
        } else {
            const errorData = await response.json();
            return {
                success: false,
                error: errorData.detail || "An unexpected error occurred. Please try again."
            };
        }
    } catch (error) {
        console.error('Login error:', error);
        return { success: false, error: 'An error occurred. Please try again.' };
    }
};

export const KonnektUserInvite = async (konnekt_id, ext_name, ext_skype_id, ext_short_name) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/konnekt/register_invite`, {
            method: 'POST',
            headers: getKonnectHeaders(),
            body: JSON.stringify({ konnekt_id, ext_name, ext_skype_id, ext_short_name })
        });

        if (response.ok) {
            const data = await response.json();
            return { success: true, data };
        } else if (response.status === 401) {
            return { success: false, error: "An error occurred. Please try again." };
        } else {
            const errorData = await response.json();
            return {
                success: false,
                error: errorData.detail || "An unexpected error occurred. Please try again."
            };
        }
    } catch (error) {
        console.error('Login error:', error);
        return { success: false, error: 'An error occurred. Please try again.' };
    }
};

//#endregion